/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M19.167 10.816H.833a.834.834 0 010-1.667h18.334a.834.834 0 010 1.667zM19.167 4.427H.833a.834.834 0 010-1.667h18.334a.834.834 0 010 1.667zM19.167 17.205H.833a.834.834 0 010-1.667h18.334a.834.834 0 010 1.667z" _fill="#fff"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/menu.js